export default __webpack_public_path__ + "static/media/dt-logo.bb74d28c.svg";